/**
 * Consent API client.
 *
 * Backend integration for consent and privacy preference operations.
 *
 * @module consentApi
 */

import { apiGet, apiPost, apiPatch } from "./apiUtils";

export interface ConsentRecord {
  id: string;
  user_id: string;
  data_processing_consent: boolean;
  consented_at: string;
  voice_recording_consent: boolean;
  consent_policy_version: number;
  created_at: string;
  updated_at: string;
}

export interface ConsentCreatePayload {
  data_processing_consent: boolean;
  voice_recording_consent: boolean;
}

export interface ConsentPatchPayload {
  voice_recording_consent: boolean;
}

export async function getMyConsent(): Promise<ConsentRecord | null> {
  return apiGet<ConsentRecord>("/v1/consent/me", { context: "getMyConsent" });
}

export async function createConsent(
  payload: ConsentCreatePayload,
): Promise<ConsentRecord | null> {
  return apiPost<ConsentRecord>("/v1/consent", payload, {
    context: "createConsent",
  });
}

export async function patchConsent(
  payload: ConsentPatchPayload,
): Promise<ConsentRecord | null> {
  return apiPatch<ConsentRecord>("/v1/consent", payload, {
    context: "patchConsent",
  });
}
